import $http from '../../utils/http'

const halykQr = {
  namespaced: true,

  state: {
  },

  getters: {
  },

  mutations: {
    set(state, { type, value }) {
      state[type] = value
    },
  },

  actions: {
    listTerminals({}, payload) {
      return $http.get(`/halyk-qr/api/terminals/${payload.bin}/list`)
    },

    connectTerminal({}, payload) {
      return $http.post('/halyk-qr/api/terminals/connect', payload)
    },

    disconnectTerminal({}, payload) {
      return $http.post('/halyk-qr/api/terminals/disconnect', payload)
    },

    generateDynamicQr({}, payload) {
      return $http.post('/halyk-qr/api/qr/dynamic', payload)
    },

    getQrStatus({}, payload) {
      return $http.get(`/halyk-qr/api/qr/status/${payload.billNumber}`)
    },

  },
}

export default halykQr
